// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3mFPj","bigColWidth":"Table_bigColWidth__6uNGY","biggerColWidth":"Table_biggerColWidth__3_nXU","row":"Table_row__1o3Qv","col":"Table_col__2C9Fi"};